//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "scienceZx",
    data() {
        return {
            content:''
        }
    },
    methods: {
        getContentByNodeName() {
            abp.ajax.get('/api/services/app/Content/GetContentByNodeName?name=' + '装修知识').then((res) => {
                //this.contents = [];
                //this.contents.push(...res.data.result);
                var list = res.data.result;
                if (list.length > 0) {
                    this.getGraphicInformationByBusiness(list[0].id)
                }
            });
        },
        getGraphicInformationByBusiness(id) {
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + id + '&businessType=content.remarks').then(res => {
                this.content = '';
                this.content = res.data.result.content;
            })
        }
    },
    created() {
        this.getContentByNodeName();
    }
}
